import { Stack } from 'component-library';
import React from 'react';

interface OnboardingPageHeadingProps {
  headlineText: string;
  sublineText?: string;
}

export const OnboardingPageHeading: React.FC<OnboardingPageHeadingProps> = ({ headlineText, sublineText }) => {
  return (
    <Stack spacing={4} className='mb-10'>
      <h3 className='typography-display2 text-center text-primary-100'>{headlineText}</h3>
      {sublineText && (
        <span className='typography-body1 text-center [text-wrap:balance]' data-testid='onboarding-page-subline'>
          {sublineText}
        </span>
      )}
    </Stack>
  );
};
